import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { M3RegService } from "./m3-reg-service";
import { M3PDinamicas } from "../Registro/m3-pdinamicas";
import { M3PItemsWEB } from "../Registro/m3-pdetalle-items";
import { M3Procesos } from "../Registro/m3-procesos";
import { ServiceM3Maestro } from "./M3Maestro.service";
import { async } from "q";



export class M3RegMasivoAKZService {


    /**
     * Agrega un EncItem y puede que una dinamica con el idprestamo a un proceso
     * @param PostServiceM3 
     * @param id_katios 
     * @param id_prestamo 
     * @param m3Prd 
     * @param user 
     */
    public async add_dinamica_idprestamo_to_proceso(PostServiceM3: PostServiceM3, id_katios: string, id_prestamo: string,
        m3Prd, user, otrosParametros: Array<any>) {
        var resp;
        var pdinamica = new M3PDinamicas
        pdinamica.Nombre = "IdPrestamo";
        pdinamica.Valor = id_prestamo;
        try {
            var response_proceso_m3: M3Procesos
            var m3_reg_service = new M3RegService(null, null, id_katios);
            response_proceso_m3 = await m3_reg_service.get_m3_proceso_by_id_prestamo_async(PostServiceM3, id_katios, id_prestamo);

            //Se dejan pegados los estados de destino
            response_proceso_m3.EstadoDes = response_proceso_m3.EstadoAnt;
            response_proceso_m3.SubEstadoDes = response_proceso_m3.SubEstadoAnt;

            resp = await this.add_pdinamica_to_existing_proceso(PostServiceM3, response_proceso_m3, id_katios, m3Prd, user, pdinamica, otrosParametros);

        } catch (err) {

            resp = await this.add_pdinamica_to_new_proceso(PostServiceM3, id_katios, m3Prd, user, pdinamica, otrosParametros);
        }
        return resp;
    }

    /**
     * Agrega un EncItem y dinamica con el idprestamo a un proceso nuevo
     * @param PostServiceM3 
     * @param id_katios 
     * @param m3Prd 
     * @param user 
     * @param pdinamica 
     */
    public async add_pdinamica_to_new_proceso(PostServiceM3: PostServiceM3, id_katios: string,
        m3Prd: any, user: any, pdinamica: M3PDinamicas, otrosParametros: Array<any>) {

        var oM3PItemsWEB;
        oM3PItemsWEB = this.GetM3PItemsWEB(otrosParametros);
        var oM3RegService = new M3RegService(null, null, id_katios);
        var response = oM3RegService.LoadM3ProcesoEmptyPDB(m3Prd, oM3PItemsWEB, user, null, null, null);
        response.lM3PDinamicas.push(pdinamica);

        //Se dejan pegados los estados de destino
        response.EstadoDes = "Activo";
        response.SubEstadoDes = "Registro";

        var m3_proceso = await oM3RegService.procesamiento_service_async(id_katios, PostServiceM3, response, user);
        return m3_proceso;
    }

    /**
     * Agrega un EncItem a un proceso existente
     * @param PostServiceM3 
     * @param m3_proceso 
     * @param id_katios 
     * @param m3Prd 
     * @param user 
     * @param pdinamica
     */
    public async add_pdinamica_to_existing_proceso(PostServiceM3: PostServiceM3, m3_proceso: M3Procesos, id_katios: string,
        m3Prd: any, user: any, pdinamica: M3PDinamicas, otrosParametros: Array<any>) {

        var oM3PItemsWEB;
        oM3PItemsWEB = this.GetM3PItemsWEB(otrosParametros);
        var oM3RegService = new M3RegService(null, null, id_katios);

        var response = oM3RegService.LoadM3ProcesoFromData(m3_proceso, m3Prd, oM3PItemsWEB, null, null, user);
        response.lM3PDinamicas.push(pdinamica);

        var m3_proceso = await oM3RegService.procesamiento_service_async(id_katios, PostServiceM3, response, user);
        return m3_proceso;
    }

    GetM3PItemsWEB(otrosParametros: Array<any>) {
        var oM3PItemsWEB = new M3PItemsWEB();
        oM3PItemsWEB.dCantidad = 1;
        oM3PItemsWEB.IdProceso = "M3VENTA";
        otrosParametros.forEach(x => {
            oM3PItemsWEB[x.Nombre] = x.Valor
        })
        return oM3PItemsWEB;
    }

}